import { Box, MenuItem, Popover, Stack } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import { OrderByEnum } from "@onair/repositories";
import { InterTypography } from "@onair/ui/typography";
import { cn } from "@onair/utils/cn";
import { useState } from "react";

interface IDocumentSort {
	orderField: string;
	handleSortDocuments: (orderField: string, order: OrderByEnum) => void;
}
const DocumentSort = ({ handleSortDocuments, orderField }: IDocumentSort) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const openPopover = Boolean(anchorEl);
	const idPopover = openPopover ? "simple-popover" : undefined;

	const handleOpenPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClosePopover = () => {
		setAnchorEl(null);
	};

	return (
		<Box component="div">
			<Box
				onClick={handleOpenPopover}
				className={cn(
					"border border-[#919EAB33] inline-block cursor-pointer hover:border-[#0050FF] transition-all",
					"px-3 py-2 rounded-full",
				)}
			>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-around"
					spacing={1}
				>
					<Iconify
						icon="basil:sort-solid"
						width={16}
						height={16}
						color={"#000"}
					/>
					<Box className="flex items-center">
						<InterTypography className="font-normal text-sm text-[#637381] text-nowrap">
							Sắp xếp:
						</InterTypography>
						<InterTypography className="font-bold text-sm text-[#212B36] text-nowrap">
							{orderField === "createdAt" ? "Theo ngày tạo" : "Theo tên"}
						</InterTypography>
					</Box>
					<Iconify
						icon={
							openPopover
								? "eva:arrow-ios-downward-fill"
								: "eva:arrow-ios-upward-fill"
						}
						width={18}
						height={18}
						color={"#0050FF"}
					/>
				</Stack>
			</Box>
			<Popover
				id={idPopover}
				open={openPopover}
				anchorEl={anchorEl}
				onClose={handleClosePopover}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<MenuItem
					onClick={() => {
						handleSortDocuments("createdAt", OrderByEnum.DESC);
						handleClosePopover();
					}}
				>
					<InterTypography
						className="font-normal text-sm w-[180px]"
						color={(theme) => theme.palette.text.primary}
					>
						Theo ngày tạo
					</InterTypography>
				</MenuItem>
				<MenuItem
					onClick={() => {
						handleSortDocuments("fileName", OrderByEnum.ASC);
						handleClosePopover();
					}}
				>
					<InterTypography
						className="font-normal text-sm"
						color={(theme) => theme.palette.text.primary}
					>
						Theo tên
					</InterTypography>
				</MenuItem>
			</Popover>
		</Box>
	);
};

export default DocumentSort;
